import { Injectable } from "@angular/core";
import { AppService } from "../../../core/service/Base.Service";

@Injectable()
export class FiDimensionbaseService extends AppService<any> {
  constructor() {
    super("FIDimension");
  }

  async GetCoaDimensions(coaid) {
    const rslt = await this.get("CoaDimensions", coaid);
    return rslt;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ixs-fidimension/fidimension/fidimensionbase.service.ts